import config from "../config/config.frn.json";
export const environment = {
  production: config.production,

  strapi_server: config.strapi_server,
  strapi_file_library: config.strapi_file_library,
  twoFactorAuth_server:config.twoFactorAuth_server,
  report_server:config.report_server,
  instance_name: config.instance_name,

  domain: config.domain,
  drawing_url: config.drawing_url,

  s3_bucket:config.s3_bucket,
  umamiProjectId:config.umamiProjectId
};